export const BASE_URL =
  process.env.REACT_APP_BE_DOMAIN || "https://triton-be.anemon.fr/";

export const BASE_URL_FE =
  process.env.REACT_APP_FE_DOMAIN || "https://triton.anemon.fr";

export const phoneNumberPrefix = "+33"

export const phoneNumberWithoutPrefix = "33"
